import React, { ReactElement } from 'react';
import { NextPage } from 'next';
import PageContainer from '../../../components/PageContainer';
import PartnerHeader from '../../../components/Layout/PartnerHeader';
import Footer from '../../../components/Layout/Footer';
import IntakeViewModel from '../../../containers/Intake/internal/IntakeViewModel';
import config from '../../../configs/social-ai/config';

const IntakeForm: NextPage = () => (
  <PageContainer>
    <IntakeViewModel config={config} />
  </PageContainer>
);

// @ts-ignore
IntakeForm.getLayout = function getLayout(page: ReactElement) {
  return (
    <>
      <PartnerHeader name={config.partner.name} />
      {page}
      <Footer />
    </>
  );
};

export default IntakeForm;
